import { polymorphic } from '../functions/polymorphic.js';
export const Svg = polymorphic.svg('', {
  viewBox: '0 0 16 16',
  width: 16,
  height: 16,
});
